import { render } from "./Dashboard.vue?vue&type=template&id=40b5b2d4&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=40b5b2d4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40b5b2d4"

export default script